import React from 'react';
import "./speakerbio.css";
import file from "../../assets/new-pdf.png";

const RelatedContent: React.FC<any> = ({ relatedContent }) => {

  return (
    <div className="content-wrapper">
      <div className="header-content">Related Content</div>
      <hr />
      {relatedContent.map((content: any, index: any) => (
        <div className="speaker" key={index}>
          <div className="pdf-wrapper">
            <a 
              href={content.url} 
              target="_blank" 
              rel="noopener noreferrer" 
              className='file-logo-wrapper'
              aria-label={`Open ${content.name} in a new tab`}
            >
              <img src={file} alt='file-logo' />
            </a>
            <a 
              href={content.url} 
              target="_blank" 
              rel="noopener noreferrer" 
              className='pdf-btn'
            >
              {content.name}
            </a>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RelatedContent;
